module.exports = __webpack_public_path__ + "static/media/over-ons_hero--bg--2.8d8d27c9.jpg";